/**
 * Module: `search/query-terms.ts` — client library utilities.
 * @remarks See exports; keep imports from concrete files when possible.
 */

/**
 * Tokens utilisés pour la recherche conversation et le surlignage (≥ 2 caractères).
 */
export function searchQueryTerms(query: string): string[] {
  return query
    .trim()
    .split(/\s+/)
    .filter((term) => term.length >= 2);
}

export function hasSearchableQueryTokens(query: string | undefined): boolean {
  return searchQueryTerms(query ?? "").length > 0;
}
